var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-tooltip/src/Tooltip.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Zoom from '@material-ui/core/Zoom';
import { NikeStylesContext } from '@nike/nr-sole-xl-theme-provider';
import TooltipPure from './TooltipPure';
import defaultStyles from './styles';

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      styleExtension = _ref.styleExtension,
      rest = _objectWithoutProperties(_ref, ["children", "styleExtension"]);

  return React.createElement(NikeStylesContext.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }, function (_ref2) {
    var attributes = _ref2.attributes,
        mergeStyles = _ref2.mergeStyles,
        globalStyleExtension = _ref2.styleExtension;
    var styles = mergeStyles(attributes, defaultStyles, globalStyleExtension.Tooltip, styleExtension);
    return React.createElement(TooltipPure, _extends({
      styles: styles
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      },
      __self: this
    }), children);
  });
};

Tooltip.propTypes = {
  /** Tooltip reference element. */
  children: PropTypes.element.isRequired,

  /** Passed down to all DOM elements to allow E2E testing. */
  'data-e2e': PropTypes.string,

  /** If true, no arrows are rendered on the tooltip. */
  disableArrow: PropTypes.bool,

  /** If true, Tooltip is deactivated. */
  disabled: PropTypes.bool,

  /** Do not respond to focus events. */
  disableFocusListener: PropTypes.bool,

  /** Do not respond to hover events. */
  disableHoverListener: PropTypes.bool,

  /** Do not respond to long press touch events. */
  disableTouchListener: PropTypes.bool,

  /** The number of milliseconds to wait before showing the tooltip. This property won't impact
   * the enter touch delay (enterTouchDelay). */
  enterDelay: PropTypes.number,

  /** The number of milliseconds a user must touch the element before showing the tooltip. */
  enterTouchDelay: PropTypes.number,

  /** Component ID. */
  id: PropTypes.string,

  /** The number of milliseconds to wait before hiding the tooltip. This property won't impact
   * the leave touch delay (leaveTouchDelay). */
  leaveDelay: PropTypes.number,

  /** The number of milliseconds after the user stops touching an element before hiding the
   * tooltip. */
  leaveTouchDelay: PropTypes.number,

  /** Callback fired when the tooltip requests to be closed. `function(event: object) => void` */
  onClose: PropTypes.func,

  /** Callback fired when the tooltip requests to be open. `function(event: object) => void` */
  onOpen: PropTypes.func,

  /** Callback that can be used to intercept open event and set internal state.
   *  `function(event: object) => void` */
  onRequestOpen: PropTypes.func,

  /** If true, the tooltip is shown. */
  open: PropTypes.bool,

  /** Tooltip placement. */
  placement: PropTypes.oneOf(['bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start']),

  /** Properties applied to the Popper element. */
  PopperProps: PropTypes.shape({}),

  /** Applied styles. */
  styleExtension: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    arrowPlacementBottom: PropTypes.object,
    arrowPlacementLeft: PropTypes.object,
    arrowPlacementRight: PropTypes.object,
    arrowPlacementTop: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    tooltipArrow: PropTypes.object,
    tooltipPlacementBottom: PropTypes.object,
    tooltipPlacementLeft: PropTypes.object,
    tooltipPlacementRight: PropTypes.object,
    tooltipPlacementTop: PropTypes.object,
    tooltipTypeAction: PropTypes.object,
    tooltipTypeError: PropTypes.object,
    tooltipTypeSuccess: PropTypes.object,
    tooltipTypeWarning: PropTypes.object,
    touch: PropTypes.object
  })]),

  /** Tooltip title. Zero-length titles string are never displayed. */
  title: PropTypes.node,

  /** Transition component. */
  TransitionComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),

  /** Properties applied to the Transition element. */
  TransitionProps: PropTypes.shape({}),

  /** A shorthand for contextual theming of the Tooltip. */
  type: PropTypes.oneOf(['action', 'default', 'error', 'success', 'warning']),

  /** If true, text is not wrapped by default. */
  wrapText: PropTypes.bool
};
Tooltip.defaultProps = {
  disableArrow: false,
  disabled: false,
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  styleExtension: {
    arrowPlacementBottom: {},
    arrowPlacementLeft: {},
    arrowPlacementRight: {},
    arrowPlacementTop: {},
    popper: {},
    tooltip: {},
    tooltipArrow: {},
    tooltipPlacementBottom: {},
    tooltipPlacementLeft: {},
    tooltipPlacementRight: {},
    tooltipPlacementTop: {},
    tooltipTypeAction: {},
    tooltipTypeError: {},
    tooltipTypeSuccess: {},
    tooltipTypeWarning: {},
    touch: {}
  },
  TransitionComponent: Zoom,
  type: 'default',
  wrapText: true
};
Tooltip.displayName = 'Tooltip';
export default Tooltip;